import {
  useContext,
  useRef,
  useState,
  useEffect,
  cloneElement,
  useCallback,
} from "react";
import { PageDisbatch } from "../../../contexts/page";
import { EditorDisbatch, EditorValue } from "../../../contexts/editor";
import { useDrop, useDrag } from "react-dnd";
import styles from "../../../components/styles.module.css";
import { getEmptyImage } from "react-dnd-html5-backend";
import useBlockNames from "../../../utils/useblocknames.js";
import useRightClick from "../../../utils/userightclick";
import { makeid } from "../../../utils/pageactions";
import useElementErrors from "../../../utils/useelementerrors";
const newId = (block) => {
  block.id = makeid(16);

  block.children.forEach((b) => {
    newId(b);
  });

  return block;
};
export default function DND(props) {
  const ref = useRef(null);
  const dispatch = useContext(PageDisbatch);
  const [after, setAfter] = useState(false);
  const editorDispatch = useContext(EditorDisbatch);
  const editor = useContext(EditorValue);
  const [hovered, setHovered] = useState(false);
  const [altKey, setAltKey] = useState();
  const { containers } = useBlockNames();
  useElementErrors({
    block: props.block,
    path: props.path,
    disabled: props.disabled,
  });

  useEffect(() => {
    const onkeyDown = (e) => {
      setAltKey(true);
    };
    const onkeyUp = (e) => {
      setAltKey(false);
    };

    window.addEventListener("keydown", onkeyDown);
    window.addEventListener("keyup", onkeyUp);

    return () => {
      window.removeEventListener("keydown", onkeyDown);
      window.removeEventListener("keyup", onkeyUp);
    };
  }, []);

  const handleDrop = useCallback(
    (item, monitor) => {
      if (!monitor.isOver({ shallow: true })) {
        return;
      }

      let fromParent = false;

      if (!item.new) {
        fromParent = item.path.every((i, index) => {
          if (props.path[index] === i) {
            return true;
          } else {
            return false;
          }
        });
      }
      if (fromParent) {
        return;
      }

      if (
        containers.includes(props.block.component) &&
        !item.new &&
        item.block.component !== props.block.component
      ) {
        dispatch({
          type: "move",
          block: item.block,
          to: [...props.path, props.block.children.length],
          from: item.path,
          after: after,
        });
        return;
      }
      if (
        containers.includes(props.block.component) &&
        item.new &&
        item.block.component !== props.block.component
      ) {
        dispatch({
          type: "insert",
          block: newId(item.block),
          path: [...props.path, props.block.children.length],
          after: after,
        });

        return;
      }
      if (!item.new) {
        dispatch({
          type: "move",
          block: item.block,
          to: [...props.path],
          from: item.path,
          after: after,
        });
        return;
      }
      dispatch({
        type: "insert",
        block: newId(item.block),
        path: [...props.path],
        after: after,
      });

      return;
    },
    [containers, props.block, after]
  );

  const handleHover = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    const cursor = monitor.getClientOffset();
    const dragBox = ref.current.getBoundingClientRect();

    if (cursor.x > dragBox.x + dragBox.width / 2) {
      setAfter(true);
    } else {
      setAfter(false);
    }
  };

  const [Menu, onContext] = useRightClick(
    {
      type: "component",
      new: true,
      block: props.block,
      path: props.path,
    },
    handleDrop
  );

  const [{}, dragRef, preview] = useDrag({
    item: {
      type: "component",
      new: altKey,
      block: props.block,
      path: props.path,
    },
    collect: (monitor, props) => ({
      isDragging: !!monitor.isDragging(),
    }),
    canDrag: (dill, monitor) => {
      return props.block.component !== "Page";
    },
  });

  useEffect(() => {
    if (ref.current) {
      const handleOnClick = (e) => {
        e.stopPropagation();
        editorDispatch({
          type: "set",
          value: { block: props.block, path: props.path },
        });
      };
      const handleHoverOver = (e) => {
        e.stopPropagation();
        setHovered(true);
      };
      const handleHoverOut = () => {
        setHovered(false);
      };
      //ref.current.style.zIndex = "1";
      //ref.current.style.position = "relative";

      ref.current.addEventListener("click", handleOnClick);
      ref.current.addEventListener("mouseover", handleHoverOver);
      ref.current.addEventListener("mouseout", handleHoverOut);
      ref.current.addEventListener("contextmenu", onContext);
      return () => {
        if (ref.current) {
          ref.current.removeEventListener("click", handleOnClick);
          ref.current.removeEventListener("mouseover", handleHoverOver);
          ref.current.removeEventListener("mouseout", handleHoverOut);
        }
      };
    }
  }, [props]);

  const [{ isOver, isIn }, dropRef] = useDrop({
    accept: props.accept ? props.accept : ["component"],
    drop: handleDrop,
    hover: handleHover,
    collect: (monitor) => ({
      isOver:
        !!monitor.isOver({ shallow: true }) &&
        (monitor.getItem().block.component === props.block.component ||
          !containers.includes(props.block.component)),
      isIn:
        !!monitor.isOver({ shallow: true }) &&
        monitor.getItem().block.component !== props.block.component &&
        containers.includes(props.block.component),
    }),
    // hover: (item, monitor) => {
    //   const {top,left} = ref.current.getClientRects();;
    // },
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  dropRef(dragRef(ref));

  useEffect(() => {
    if (ref.current) {
      if (isIn) {
        return (ref.current.className = styles.inside);
      }
      if (isOver && after) {
        return (ref.current.className = styles.after);
      }
      if (isOver && !after) {
        return (ref.current.className = styles.before);
      }
      if (editor && editor.block.id === props.block.id) {
        return (ref.current.className = styles.active);
      }
      if (hovered) {
        return (ref.current.className = styles.hovered);
      }
      ref.current.className = "";
    }
  }, [hovered, isIn, isOver, after, editor]);

  return (
    <>
      {cloneElement(props.children, { editorRef: ref, ...props })}
      {Menu}
    </>
  );
}
